import { useQuery } from '@tanstack/react-query';

import type { AccountConfig } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/extranet/account/config` — route absente du contrat v1.8.4.
 * Désactivé via `FEATURES.accountConfigRoute` ; `defaultAccountConfig` alimente
 * l'UI en attendant.
 */
export const useAccountConfig = (enabled: boolean) =>
  useQuery({
    queryKey: extranetQueryKeys.account.config(),
    queryFn: () => getExtranetApi().get<Record<string, never>, AccountConfig>('/v1/extranet/account/config', {}),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
